import React, { useState } from "react";
import * as emailjs from 'emailjs-com';

const Contact = ({ darkMode }) => {
    
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")

    const handleSubmit = (event) => {
        event.preventDefault();

        const templateParams = {
            from_name: name,
            from_email: email,
            to_name: 'Fotoset',
            message_html: message,
           }
           
           emailjs.send(
            `${process.env.REACT_APP_SERVICE_KEY}`,
            `${process.env.REACT_APP_TEMPLATE_KEY}`,
             templateParams,
            `${process.env.REACT_APP_EMAIL_KEY}`
           )
            setName("")
            setEmail("")
            setMessage("")
    }

      return (
<div className="contact-page">
        {darkMode ? (
            <>
            <h1 style={{color: "white", borderBottom: "2px solid white", lineHeight: "50px"}}>CONTACT US</h1>
            <div className="contact-container">
                <h3 style={{color: "white"}}>We'd love to hear from you</h3>
                <h4 style={{color: "white"}}>We like to create things that enable creativity</h4>
            </div>
            </>
            ):(
                <>
            <h1>CONTACT US</h1>
            <div className="contact-container">
                <h3>We'd love to hear from you</h3>
                <h4>We like to create things that enable creativity</h4>
            </div>
            </>
            )}
    <div className="contact-details">
      <div className="details-container">
        <div className="full-left-side">
            <br/>
            <form onSubmit={handleSubmit}>
                <label>Full Name</label><br></br>
                <input
                    type="text"
                    name="name"
                    value={name}
                    className="contact-box"
                    placeholder="full name..."
                    onChange={(e) => setName(e.target.value)}
                /><br></br>

                <label>Email</label><br></br>
                <input
                    type="text"
                    name="email"
                    value={email}
                    className="contact-box"
                    placeholder="email..."
                    onChange={(e) => setEmail(e.target.value)}
                /><br></br>

                <label>Message</label><br></br>   
                <textarea
                    type="text"
                    name="message"
                    value={message}
                    className="contact-box"
                    placeholder="message us..."
                    onChange={(e) => setMessage(e.target.value)}
                /><br></br>
                    <div className="main-button">
                        <button type="submit" className="send-btn">Send</button>
                    </div>
                </form>
        </div>
        <div className="full-right-side">
            <h3 style={{fontSize: "20px"}}><i className="fas fa-envelope"></i> yushiys95@gmail.com</h3>
            <h3 style={{fontSize: "20px", marginTop: "2.5rem"}}><i style={{color: "#77acf1"}} className="fas fa-phone"></i> 777-777-7777</h3>
            <h4><i style={{color: "red"}} className="fas fa-map-marker-alt"></i> New York, NY</h4>
            <br/>
            <div className="icon-container">
                <ul>
                    <li><a className="linkedin" href="https://www.linkedin.com/in/yushi95"><i className="fab fa-linkedin"></i></a></li>
                    <li><a className="instagram" href="https://www.instagram.com/yushi.95"><i className="fab fa-instagram"></i></a></li>
                    <li><a className="medium" href="https://yushi95.medium.com/"><i className="fab fa-medium-m"></i></a></li>
                    <li><a className="github" href="https://github.com/yushi1007"><i className="fab fa-github"></i></a></li>
                </ul>
            </div>
            <hr/>
        </div>
      </div>
    </div>
</div>
      )
}

export default Contact;